import ManagePipelinesDialog from './ManagePipelinesDialog';

export default ManagePipelinesDialog;
